export function toDropdownList(enumObject:  Record<string, string>): { label: string; value: string }[] {
  return Object.values(enumObject!)
    .filter((item) => item !== undefined && item !== null && typeof item === 'string')
    .map((value: string) => {
      return {
        label: value.toString(),
        value: value.toString()
      };
    });
}
